import React from "react";

const HorizontalBar = ({ items, maxValue, color = "bg-red-500" }) => {
  if (!items || items.length === 0) {
    return (
      <div className="flex items-center justify-center h-24 text-gray-400 text-sm">
        No data available
      </div>
    );
  }

  const max = maxValue || Math.max(...items.map((i) => i.value), 1);

  return (
    <div className="space-y-2">
      {items.map((item, i) => (
        <div key={i} className="flex items-center gap-2">
          <span className="text-xs w-24 truncate text-right text-gray-600">
            {item.label}
          </span>
          <div className="flex-1">
            <div className="w-full bg-gray-200 rounded-full h-3">
              <div
                className={`${color} h-3 rounded-full transition-all duration-300`}
                style={{
                  width: `${(item.value / max) * 100}%`,
                  minWidth: item.value > 0 ? "4px" : "0px",
                }}
              />
            </div>
          </div>
          <span className="text-xs font-medium w-12 text-right text-gray-700">
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default HorizontalBar;
